var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_115374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 -3.05176e-05H2.34375C1.05139 -3.05176e-05 0 1.05111 0 2.34316V13.6529C0 14.945 1.05139 15.9961 2.34375 15.9961H13.6562C14.9486 15.9961 16 14.945 16 13.6529V2.34316C16 1.05111 14.9486 -3.05176e-05 13.6562 -3.05176e-05ZM15.0625 13.6529C15.0625 14.4281 14.4316 15.0588 13.6562 15.0588H2.34375C1.56836 15.0588 0.9375 14.4281 0.9375 13.6529V2.34316C0.9375 1.56795 1.56836 0.937244 2.34375 0.937244H13.6562C14.4316 0.937244 15.0625 1.56795 15.0625 2.34316V13.6529Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53125 6.59214C7.53125 5.55845 6.69019 4.71759 5.65625 4.71759H2.84375V11.2785H5.65625C6.69019 11.2785 7.53125 10.4376 7.53125 9.40396C7.53125 8.84453 7.28455 8.34184 6.89441 7.99805C7.28455 7.65426 7.53125 7.15158 7.53125 6.59214ZM6.59375 9.40396C6.59375 9.92081 6.17322 10.3412 5.65625 10.3412H3.78125V8.46669H5.65625C6.17322 8.46669 6.59375 8.88712 6.59375 9.40396ZM3.78125 7.52941V5.65486H5.65625C6.17322 5.65486 6.59375 6.0753 6.59375 6.59214C6.59375 7.10898 6.17322 7.52941 5.65625 7.52941H3.78125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 6.59213C9.52014 6.59213 8.46875 7.64327 8.46875 8.93532C8.46875 10.2274 9.52014 11.2785 10.8125 11.2785C11.6466 11.2785 12.4244 10.8298 12.8424 10.1073L12.0309 9.63791C11.7799 10.0718 11.313 10.3412 10.8125 10.3412C10.2013 10.3412 9.68005 9.94948 9.48657 9.40396H13.1563V8.93532C13.1563 7.64327 12.1049 6.59213 10.8125 6.59213ZM9.48657 8.46668C9.68005 7.92116 10.2013 7.52941 10.8125 7.52941C11.4237 7.52941 11.9449 7.92116 12.1384 8.46668H9.48657Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199554
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 4.71759H12.6875V5.65486H8.9375V4.71759Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.199554
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_115374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9962,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.ac3608da2c589d60bf2266c1e2874b78.svg";
export { ForwardRef as ReactComponent };